<script>
import axios from "axios";
import _ from "lodash";
import { PrismEditor } from "vue-prism-editor";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";
// eslint-disable-next-line
import Prism from "prismjs";

import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere


import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";

export default {
  name: "IpImport",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    PrismEditor,
  },
  data() {
    return {
      loadDCsUrl: '/api/manager/dc/list?sort=Id',
      apiUrl: '/api/manager/ip/',
      DcList: [],
      formData: {
        DcId: null,
        Import: null
      }
    }
  },
  methods: {
    modalClosed() {
      this.formData = {
        DcId: null,
        Import: null
      }
      this.$modal.hide('IpImport');
    },
    modalOpened() {
      this.getDcList()
    },
    submitForm() {
      let loader = this.$loading.show();
      axios.post(this.apiUrl, {...this.formData}, this.authRespConf())
          .then((res) => {
            loader.hide();
            this.$bvToast.toast(res.data.message, {
              title: `Successfully request`,
              noAutoHide: true,
              variant: 'success',
              appendToast: true
            })
            this.modalClosed()
          })
          .catch((err) => {
            loader.hide();
            this.moveUp();
            this.errorHandle(err, true, true);
          });
    },
    highlighter(code) {
      const formats = [
        /^(\S+)\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+([0-9A-Fa-f]{2}(?::[0-9A-Fa-f]{2}){5})$/,
        /^(\S+)\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})$/,
        /^(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+([0-9A-Fa-f]{2}(?::[0-9A-Fa-f]{2}){5})$/,
        /^(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})$/,
        /^(\S+)\s+(\d{1,3}(?:\.\d{1,3}){3})$/,
        /^(\d{1,3}(?:\.\d{1,3}){3})$/,
      ];

      const lines = code.split('\n');
      return lines.map(line => {
        let matched = false;
        for (let format of formats) {
          if (format.test(line)) {
            matched = true;
            break;
          }
        }
        if (matched) {
          return `<span class="correct-format">${line}</span>`;
        } else {
          return `<span class="incorrect-format">${line}</span>`;
        }
      }).join('\n');
    },
    highlightFormat() {
      // This method can be used for additional processing if needed
    },
    getDcList() {
      let loader = this.$loading.show();
      axios.post(this.loadDCsUrl, [],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.DcList = _.map(res.data.data, (item) => {
                return {
                  label: item.Name,
                  value: item.Id
                }
              })
            }
          })
    },
  }
}
</script>

<template>
  <div class="wrapper">
    <modal
        name="IpImport"
        :draggable="true"
        :resizable="true"
        :clickToClose="false"
        :width="850"
        :min-width="425"
        :min-height="200"
        :height="500"
        :scrollable="true"
        @closed="modalClosed"
        @opened="modalOpened"
        class="modalBox"
        :style="{'--selectHeight': '120px'}"
    >
      <div class="window-header">
        New IPs
        <a href="javascript:void(0)" class="close-modal pull-right" @click="modalClosed()"><i
            class="fa fa-times"></i></a>
      </div>
      <div class="modal-body">
        <div class="page-modal" style="background: white;">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 col-form-label">Datacenter <span class="text-danger">*</span></label>
              <div class="col-sm-10">
                <v-select
                    :options="DcList"
                    label="label"
                    v-model="formData.DcId"
                    :reduce="server => server.value"
                    placeholder="Select Datacenter.."
                    required
                    inputId="Type"/>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 col-form-label">Import IPs <span class="text-danger">*</span></label>
              <div class="col-sm-10">
                <p class="help-text m-0"><i class="fa fa-info-circle"></i>
                  <span v-text="'[hostname] <ip> <netmask> <gateway> [MAC-Addr]'"/>
                </p>
                <prism-editor
                    class="editor min-height-300"
                    v-model="formData.Import"
                    :highlight="highlighter"
                    line-numbers
               />
<!--                <b-form-textarea-->
<!--                    class="form-control"-->
<!--                    required-->
<!--                    placeholder="N/A"-->
<!--                    v-model="formData.Import"></b-form-textarea>-->
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="submitForm()" class="btn btn-primary">Create</button>
        <button
            class="btn btn-default"
            href="javascript:void(0);"
            v-on:click="modalClosed()"
            type="button"
        >
          <span>Cancel</span>
        </button>
      </div>
    </modal>
  </div>
</template>

<style>
.editor {
  background: #fff;
  border: 1px solid #8cbbee;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}
.height-300 {
  height: 10rem;
}
.min-height-300 {
  min-height: 10rem;
}
.correct-format {
  color: green;
}
.incorrect-format {
  color: red;
}
.prism-editor__textarea:focus {
  outline: none;
}
.prism-editor__container {
  height: 100%;
}
pre span.incorrect-format:empty:after {
  content: 'Not assigned';
}

</style>